import { FC } from 'react';
import { IMAGE_PLACEHOLDER } from 'src/utils/variables';

import {
  Container,
  Description,
  HotelLogo,
  HotelLogoWrapper,
  Label,
  LabelIcon,
  LabelsContainer,
  LabelText,
  Title,
} from './CoverImage.styled';

export type CoverImageProps = {
    logo?: string;
    cover: string;
    title?: string;
    description?: string;
    labels?: {
      value: string;
      icon: string;
      type?: string;
    }[];
}

export const CoverImage: FC<CoverImageProps> = ({ logo, cover, title, description, labels }) => (
  <Container cover={cover || IMAGE_PLACEHOLDER} data-testid="hotel-banner">
    {logo && (
    <HotelLogoWrapper>
      <HotelLogo src={logo || IMAGE_PLACEHOLDER} alt="hotel-logo" />
    </HotelLogoWrapper>
    )}
    {title && (
    <Title>{title}</Title>
    )}
    {labels && (
      <LabelsContainer>
        {labels.map((label) => {
          const isLink = label.type === 'email' || label.type === 'phone';
          let href = '';

          if (label.type === 'email') {
            href = `mailto:${label.value}`;
          } else if (label.type === 'phone') {
            href = `tel:${label.value}`;
          }

          return (
            <Label as={isLink ? 'a' : 'div'} href={isLink ? href : undefined} key={label.value}>
              <LabelIcon src={label.icon} alt="icon" />
              <LabelText>{label.value}</LabelText>
            </Label>
          );
        })}
      </LabelsContainer>
    )}
    {description && <Description>{description}</Description>}
  </Container>
);
